import { FileTextOutlined } from "@ant-design/icons";
import { Button, Modal, DatePicker, Table, Space, Tooltip, Typography, Badge } from "antd";
import { useState, useEffect } from "react";
import dayjs from "dayjs";
import useComprobantesSinCAE from "./useComprobantesSinCAE";
import { autorizarCAEMasivo } from "./api";

const { RangePicker } = DatePicker;

const AutorizarCae = ({ buttonStyles }) => {
  const [open, setOpen] = useState(false);

  const [fechas, setFechas] = useState([
    dayjs().subtract(1, "day"),
    dayjs(),
  ]);

  const { comprobantes, fetch, loading } = useComprobantesSinCAE();

  const cantidad = Array.isArray(comprobantes) ? comprobantes.length : 0;

  const handleChangeFechas = (val) => {
    setFechas(val);

    if (!val) return;

    fetch({
      fecha_inicio: val[0].format("YYMMDD"),
      fecha_fin: val[1].format("YYMMDD"),
    });
  };

  const handleAutorizar = async () => {
    if (!fechas) return;

    await autorizarCAEMasivo({
      fecha_inicio: fechas[0].format("YYMMDD"),
      fecha_fin: fechas[1].format("YYMMDD"),
    });

    setOpen(false);
    fetch({
      fecha_inicio: fechas[0].format("YYMMDD"),
      fecha_fin: fechas[1].format("YYMMDD"),
    });
  };

  useEffect(() => {
    fetch({
      fecha_inicio: fechas[0].format("YYMMDD"),
      fecha_fin: fechas[1].format("YYMMDD"),
    });
  }, [open, fechas]);

  const columns = [
    { title: "Comprobante ID", dataIndex: "id_nro_auxiliar" },
    { title: "Cliente", dataIndex: "razon_social", ellipsis: true, width: 200 },
    { title: "CUIT", dataIndex: "cuit" },
    {
      title: "Total",
      dataIndex: "total",
      render: (value) => `$ ${value?.toLocaleString("es-AR")}`,
    },
    {
      title: "Motivo",
      dataIndex: "motivo",
      width: 400,
      render: (text) => (
        <Typography.Text type="danger">
          {text}
        </Typography.Text>
      )
    },
    { title: "Filial", dataIndex: "filial" },
  ];

  return (
    <>
      <Tooltip title="Autorizar CAE">
        <Button
          type="text"
          style={buttonStyles}
          icon={
            <Badge
              count={cantidad}
              showZero={false}
              size="small"
              offset={[5, -2]}
              style={{ boxShadow: "none", padding: "0 4px" }}
            >
              <FileTextOutlined style={{ color: buttonStyles?.color }} />
            </Badge>
          }
          onClick={() => setOpen(true)}
        />
      </Tooltip>

      <Modal
        title="Autorizar CAE"
        open={open}
        onCancel={() => setOpen(false)}
        width={1200}
        footer={[
          <Button key="cancelar" onClick={() => setOpen(false)}>
            Cancelar
          </Button>,
          <Button key="autorizar" type="primary" onClick={handleAutorizar}>
            Autorizar CAE
          </Button>,
        ]}
      >
        <Space style={{ width: "100%", justifyContent: "space-between" }}>
          <RangePicker
            size="small"
            value={fechas}
            onChange={handleChangeFechas}
            style={{ width: 240 }}
            allowClear={false}
          />

          <Typography.Text>
            Cantidad: <b>{cantidad}</b>
          </Typography.Text>
        </Space>

        <Table
          dataSource={comprobantes}
          columns={columns}
          rowKey="id_nro_auxiliar"
          size="small"
          loading={loading}
          pagination={false}
          scroll={{ y: 300 }}
        />
      </Modal>
    </>
  );
};

export default AutorizarCae;